import { set, get } from '../lib/storage/isomorphicSessionStorage'

// When changing the structure of local storage item change the key so that
// errors are not created on users browsers.
const KEY = 'offerComparisonV1'

export function storeComparisonState(state: App.OfferComparisonState) {
  return set(KEY, state)
}

export function retrieveComparisonState(): App.OfferComparisonState | null {
  return get(KEY) || null
}
